import { io } from "socket.io-client";

// "undefined" means the URL will be computed from the `window.location` object
const URL =
  process.env.NODE_ENV === "production" ? undefined : "http://localhost:4000";

export const socket = new WebSocket(
  `ws://127.0.0.1:3000/ws?conversation_id=${123}`
);
